// Components==============
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import PageHeader from 'components/UI/PageHeader/PageHeader';
import React from 'react';
import './Page.module.scss';
// =========================

export default function Page() {
    return (
        <Layout>
            <PageHeader />
            <Container background>
                <HeroLayout />
            </Container>
        </Layout>
    );
}
